import React from "react";
import { useNavigate } from "react-router-dom";
import UtilsUnit from "../../../utils/UtilsUnit";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";

// CSS/Stylesheets
import "./WidgetSmallTransportationTitle.css";

const WidgetSmallTransportationTitle = () => {
  const navigate = useNavigate();

  return (
    <DivColumn className="transportation-title-widget" onClick={() => UtilsUnit.handleSearchTerminalClick(navigate)}>
      <WidgetIconFive iconProp={ConstantsImages.TRANSPORTATION_SMALL_IMAGE} widthIconProp="5.2rem" heightIconProp="9.8rem" />
      <ParagraphText className="model-text-shared-1">{ConstantsTexts.CODE_1}</ParagraphText>
    </DivColumn>
  );  
};

export default WidgetSmallTransportationTitle;
